import { render, staticRenderFns } from "./Competitive.vue?vue&type=template&id=3abc89cc&scoped=true&"
import script from "./Competitive.vue?vue&type=script&lang=js&"
export * from "./Competitive.vue?vue&type=script&lang=js&"
import style0 from "./Competitive.vue?vue&type=style&index=0&id=3abc89cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc89cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
